import { Button, Drawer } from 'antd';
import { useEffect, useState } from 'react';
import { editMember } from '../../../../../api';
import {
  messageError,
  messageSuccess,
} from '../../../../../components/message';
import getFormatMessage from '../../../../../locales/get-format-message';
import closeIcon from '../../../../../assets/svg/close-icon.svg';
import { IAPIStudioMemberHasPermissionItem } from '../../../../../model/api-modules';
import { RoleGroupType } from '../../../../../model/rbac';
import { IOption } from '../../organization-content';
import { SelectRoleGroupComponent } from './select-role-group';

interface IProps {
  readonly onClose: (status?: boolean) => void;
  readonly row: IAPIStudioMemberHasPermissionItem;
  readonly roleGroupNames: string[];
  readonly roleName: string | undefined;
  readonly rolesAndGroupsOptions: IOption[];
  readonly studioId: string;
  // readonly rolesList: ReadonlyArray<IRBACRole>;
  // readonly userGroupsList: ReadonlyArray<IRBACUserGroup>;
}

export const EditMemberDrawer = (props: IProps) => {
  // const [error, setError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [roleGroupList, setRoleGroupList] = useState<string[]>([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);
  const [authType, setAuthType] = useState<RoleGroupType>(RoleGroupType.Role);

  const handleRoleGroupChange = (
    selectedOptions: string[],
    authType: RoleGroupType.Role | RoleGroupType.Group
  ) => {
    console.log('编辑roleGroupList', selectedOptions, authType);
    setRoleGroupList(selectedOptions);
    setAuthType(authType);
  };

  useEffect(() => {
    if (roleGroupList) {
      setIsButtonDisabled(roleGroupList.length === 0);
    }
  }, [roleGroupList]);

  const handleOpenCancel = () => {
    props.onClose();
  };
  const handleOpenSubmit = async () => {
    setLoading(true);
    try {
      const roleGroupLists = roleGroupList.map((group) => {
        if (group.startsWith('roleGroup-')) {
          return parseInt(group.substring(10), 10);
        }
        if (group.startsWith('userGroup-')) {
          return parseInt(group.substring(10), 10);
        }
        return 0;
      });
      // console.log('提交编辑方法,roleGroupLists', authType, roleGroupLists);
      // 需要编辑方法
      // 编辑用户为角色或者用户组
      const res = await editMember(
        props.studioId,
        [props.row.UserID],
        '', // url传空
        authType,
        roleGroupLists
      );
      console.log('编辑res=====', res);
      if (res) {
        if (res.code === 0) {
          messageSuccess(getFormatMessage('edit_success'));
          // confirmDiscardChanges();
          props.onClose(true);
        } else {
          messageError(getFormatMessage('edit_fail'));
        }
      }
    } catch (error: any) {
      messageError(getFormatMessage('edit_fail'));
      return false;
    } finally {
      setLoading(false);
    }
  };

  return (
    <Drawer
      onClose={() => props.onClose()}
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>{getFormatMessage('edit_member')}</span>
          <img
            src={closeIcon}
            className="sync-close-icon"
            onClick={() => props.onClose()}
          />
        </div>
      }
      placement="right"
      width={520}
      closable={false}
      visible={true}
      headerStyle={{
        position: 'sticky',
        top: 0,
        zIndex: 1,
        marginLeft: '3px',
      }}
      footer={
        <div
          style={{
            textAlign: 'left',
          }}
        >
          <button
            className="gc-btn sub-button"
            onClick={handleOpenCancel}
            disabled={loading}
          >
            {getFormatMessage('cancel')}
          </button>
          <Button
            className="gc-btn gc-btn-primary gc-btn-download"
            loading={loading}
            disabled={isButtonDisabled}
            onClick={handleOpenSubmit}
          >
            {getFormatMessage('save')}
          </Button>
        </div>
      }
    >
      <div className="edit-member">
        <div className="edit-title">{getFormatMessage('member_name')}</div>
        <div className="edit-content">{props.row.UserName}</div>
        <div className="edit-title">{getFormatMessage('email_uppercase')}</div>
        <div className="edit-content">{props.row.UserID}</div>
        <div style={{ marginTop: 28 }}>
          <SelectRoleGroupComponent
            roleGroupNames={props.roleGroupNames}
            roleName={props.roleName}
            row={props.row}
            rolesAndGroupsOptions={props.rolesAndGroupsOptions}
            setRoleGroupList={handleRoleGroupChange}
          />
        </div>
      </div>
    </Drawer>
  );
};
